import {
    CLEAR_USER_SHIFTS,
    FETCH_USER_SHIFTS,
    LIST_USER_SHIFTS
} from "./types";

const init = {
    isLoading: false,
    filter: {
        roleCode: "member",
        lotteryType: "",
        keyword: "",
        page: 1,
        size: 50
    },
    rows: [],
    paging: {
        page: 0,
        size: 50,
        totals: 0
    }
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_USER_SHIFTS:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...payload
                },
                isLoading: true
            };
        case LIST_USER_SHIFTS:
            return {
                ...state,
                isLoading: false,
                rows: payload.data || [],
                paging: {
                    page: payload.paging?.page ?? 0,
                    size: payload.paging?.size ?? state.filter.size,
                    totals: payload.paging?.totals ?? 0
                }
            };
        case CLEAR_USER_SHIFTS:
            return {
                ...init
            };
        default:
            return state;
    }
}
